module.exports = __webpack_public_path__ + "03_glasses_red.e2af8a5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer4/03_glasses_red.png
// module id = IJ84
// module chunks = 0